import { useEffect, useState } from "react";
import MainComponentWrapper from "../../Common/MainComponentWrapper";
import CreateEventFormTab from "./CreateEventFormTab";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useHttpHook from "../../../Hooks/HttpHook";
import { EventById, GetAddonsApi } from "../../../utils/ApiConstant";
import { updEventData } from "../../../ReduxSlice/Event/eventSlice";
import { useDispatch } from "react-redux";
import SubmitButtonGroup from "../../UiElement/FormElement/SubmitBtnGroup";
import AddonsList from "../../../Pages/Organizer/EventMgt/AddonsList";
import CreateAddonModal from "./CreateAddonModal";
import DeleteAddonModal from "./DeleteAddonModal";

const Addons = (props) => {
  const [loading, sendRequest, error] = useHttpHook();
  const [addon, setAddon] = useState(null);
  const [addonLoading, setAddonLoading] = useState(false);
  const [addonId, setAddonId] = useState(null);
  const [showDeleteAddonModal, setShowDeleteAddonModal] = useState(false);
  const { showAddonModal, onCloseAddonModal, setShowAddonModal } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const { eventId } = useParams();
  const dispatch = useDispatch();
  const isOnlyTicket = Boolean(location?.state?.isOnlyTickets);

  const getEventData = async () => {
    const event = await sendRequest(EventById + eventId);
    dispatch(updEventData(event));
  };

  const [addons, setAddons] = useState([]);
  const getAddons = async () => {
    try {
      setAddonLoading(true);
      const response = await sendRequest(GetAddonsApi + eventId);
      if (response.status === 1) {
        setAddons(response.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setAddonLoading(false);
    }
  };

  useEffect(() => {
    if (eventId) {
      getAddons();
    }
  }, [eventId]);

  useEffect(() => {
    getEventData();
  }, []);

  return (
    <MainComponentWrapper Loading={loading || addonLoading} errorInfo={error}>
      <div className="evntFormUI event-addons-page">
        <div className="eventCreationFrom">
          <CreateEventFormTab Id="addons" isOnlyTicket={isOnlyTicket} />

          <section className="event-addons-panel" aria-label="Event add-ons">
            <AddonsList
              actions={(data) => (
                <>
                  <button
                    type="button"
                    title="Edit"
                    className="event-addon-card-action is-edit"
                    onClick={(e) => {
                      e.stopPropagation();
                      setAddon(data);
                      setShowAddonModal(true);
                    }}
                    aria-label="Edit add-on"
                  >
                    <i className="bi bi-pencil" aria-hidden="true" />
                  </button>
                  <button
                    type="button"
                    title="Delete"
                    className="event-addon-card-action is-delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowDeleteAddonModal(true);
                      setAddonId(data._id);
                    }}
                    aria-label="Delete add-on"
                  >
                    <i className="bi bi-trash" aria-hidden="true" />
                  </button>
                </>
              )}
              redirection={false}
              addons={addons}
              showHeading={false}
              loading={addonLoading}
              error={error}
              eventId={eventId}
              onCreateAddon={() => setShowAddonModal(true)}
            />
          </section>

          <CreateAddonModal
            addon={addon}
            show={showAddonModal}
            getAddons={getAddons}
            onClose={() => {
              onCloseAddonModal();
              setAddon(null);
            }}
          />
          <DeleteAddonModal
            show={showDeleteAddonModal}
            onClose={() => {
              setShowDeleteAddonModal(false);
              setAddonId(null);
            }}
            getAddons={getAddons}
            addonId={addonId}
          />
        </div>

        {!isOnlyTicket && (
          <SubmitButtonGroup
            clickHandler={() => {
              navigate(`/myEvents/${eventId}/publish`, { replace: true });
            }}
            isLoading={loading || addonLoading}
            GroupClassName="event-addons-footer event-settings-footer"
          />
        )}
      </div>
    </MainComponentWrapper>
  );
};

export default Addons;
